// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────
   OdsDateFilter — wrapper
──────────────────────────────────────────────────────────────── */
.ods-date-filter-wrapper {
  position: relative;
  display: inline-block;
}

/* ── Trigger pill ── */
.ods-date-filter-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-white);
  padding: 8px 14px;
  border-radius: 50px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
  box-shadow:
    0 -1px 3px rgba(0, 0, 0, 0.04),  /* top shadow */
    0 -1px 2px rgba(0, 0, 0, 0.02),  /* soft top */
    0 1px 3px rgba(0, 0, 0, 0.04),   /* bottom shadow */
    0 1px 2px rgba(0, 0, 0, 0.02);   /* soft bottom */
}

.ods-date-filter-pill:hover {
  background: #e8eaed;
}

.ods-date-filter-text {
  font-size: 0.838rem;
  font-weight: 700;
  color: #4c4f5c;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.ods-date-icon-left {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}

.ods-date-icon-right {
  width: 14px;
  height: 14px;
  color: #6b7280;
  flex-shrink: 0;
}

/* ── Dropdown card ── */
.ods-date-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: auto;
  z-index: 9999;
  background: #ffffff;
  border-radius: 10px;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
  width: 280px;
  animation: ods-date-fadein 0.15s ease;
}

@keyframes ods-date-fadein {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Header: "April, 2026 ▾"  +  ↑ ↓ ── */
.ods-date-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.ods-date-month-label {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1a1a2e;
  cursor: default;
}

.ods-date-nav {
  display: flex;
  gap: 6px;
}

.ods-date-nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: #4c4f5c;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  transition: background 0.12s;
}

.ods-date-nav-btn:hover {
  background: #f1f3f5;
}

/* ── Day-of-week labels: Su Mo Tu We Th Fr Sa ── */
.ods-date-day-labels {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 6px;
}

.ods-date-day-label {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
}

/* ── 7-col date grid ── */
.ods-date-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.ods-date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin: 0 auto;
  font-size: 0.813rem;
  font-weight: 500;
  color: #1a1a2e;
  border-radius: 50%;
  cursor: pointer;
  transition:
    background 0.12s,
    color 0.12s;
}

.ods-date-cell:hover:not(.ods-date-cell-outside):not(.ods-date-cell-selected) {
  background: #f1f3f5;
}

/* Outside-month days — greyed out, not clickable */
.ods-date-cell-outside {
  color: #d1d5db;
  cursor: default;
  pointer-events: none;
}

/* Selected day — solid blue circle (matches reference) */
.ods-date-cell-selected {
  background: #2563eb;
  color: #ffffff !important;
  font-weight: 700;
  border-radius: 50%;
}

/* Today — bordered square (matches reference) */
.ods-date-cell-today {
  border: 1.5px solid #9ca3af;
  border-radius: 4px; /* square not circle, matching reference */
  color: #1a1a2e;
}

/* ── Footer: Clear / Today ── */
.ods-date-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #f1f3f5;
}

.ods-date-footer-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.838rem;
  font-weight: 600;
  color: #2563eb;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background 0.12s;
}

.ods-date-footer-btn:hover {
  background: #eff6ff;
}

.ods-date-dot {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 5px;
  height: 5px;
  background-color: #ef4444;
  border-radius: 50%;
}

/* ── Dark theme ── */
.dark .ods-date-filter-pill {
  background: #1e293b;
}

.dark .ods-date-filter-pill:hover {
  background: #334155;
}

.dark .ods-date-filter-text {
  color: #e2e8f0;
}

.dark .ods-date-icon-left,
.dark .ods-date-icon-right {
  color: #94a3b8;
}

.dark .ods-date-dropdown {
  background: #1e293b;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.4),
    0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark .ods-date-month-label {
  color: #f1f5f9;
}

.dark .ods-date-nav-btn {
  color: #94a3b8;
}

.dark .ods-date-nav-btn:hover {
  background: #334155;
}

.dark .ods-date-day-label {
  color: #64748b;
}

.dark .ods-date-cell {
  color: #e2e8f0;
}

.dark .ods-date-cell:hover:not(.ods-date-cell-outside):not(.ods-date-cell-selected) {
  background: #334155;
}

.dark .ods-date-cell-outside {
  color: #475569;
}

.dark .ods-date-cell-today {
  border-color: #64748b;
  color: #e2e8f0;
}

.dark .ods-date-footer {
  border-top-color: #334155;
}

.dark .ods-date-footer-btn:hover {
  background: #1e3a5f;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/OdsDateFilter/OdsDateFilter.css"],"names":[],"mappings":"AAAA;;kEAEkE;AAClE;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B;;;;iCAI+B,IAAI,gBAAgB;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;;iCAE+B;EAC/B,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,kBAAkB,EAAE,0CAA0C;EAC9D,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB;;gCAE8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ────────────────────────────────────────────────────────────────\n   OdsDateFilter — wrapper\n──────────────────────────────────────────────────────────────── */\n.ods-date-filter-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* ── Trigger pill ── */\n.ods-date-filter-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-white);\n  padding: 8px 14px;\n  border-radius: 50px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s;\n  box-shadow:\n    0 -1px 3px rgba(0, 0, 0, 0.04),  /* top shadow */\n    0 -1px 2px rgba(0, 0, 0, 0.02),  /* soft top */\n    0 1px 3px rgba(0, 0, 0, 0.04),   /* bottom shadow */\n    0 1px 2px rgba(0, 0, 0, 0.02);   /* soft bottom */\n}\n\n.ods-date-filter-pill:hover {\n  background: #e8eaed;\n}\n\n.ods-date-filter-text {\n  font-size: 0.838rem;\n  font-weight: 700;\n  color: #4c4f5c;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.ods-date-icon-left {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.ods-date-icon-right {\n  width: 14px;\n  height: 14px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n/* ── Dropdown card ── */\n.ods-date-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: auto;\n  z-index: 9999;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.12),\n    0 2px 8px rgba(0, 0, 0, 0.06);\n  padding: 16px;\n  width: 280px;\n  animation: ods-date-fadein 0.15s ease;\n}\n\n@keyframes ods-date-fadein {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── Header: \"April, 2026 ▾\"  +  ↑ ↓ ── */\n.ods-date-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.ods-date-month-label {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #1a1a2e;\n  cursor: default;\n}\n\n.ods-date-nav {\n  display: flex;\n  gap: 6px;\n}\n\n.ods-date-nav-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #4c4f5c;\n  padding: 2px 6px;\n  border-radius: 4px;\n  line-height: 1;\n  transition: background 0.12s;\n}\n\n.ods-date-nav-btn:hover {\n  background: #f1f3f5;\n}\n\n/* ── Day-of-week labels: Su Mo Tu We Th Fr Sa ── */\n.ods-date-day-labels {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 6px;\n}\n\n.ods-date-day-label {\n  text-align: center;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #9ca3af;\n}\n\n/* ── 7-col date grid ── */\n.ods-date-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.ods-date-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  margin: 0 auto;\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #1a1a2e;\n  border-radius: 50%;\n  cursor: pointer;\n  transition:\n    background 0.12s,\n    color 0.12s;\n}\n\n.ods-date-cell:hover:not(.ods-date-cell-outside):not(.ods-date-cell-selected) {\n  background: #f1f3f5;\n}\n\n/* Outside-month days — greyed out, not clickable */\n.ods-date-cell-outside {\n  color: #d1d5db;\n  cursor: default;\n  pointer-events: none;\n}\n\n/* Selected day — solid blue circle (matches reference) */\n.ods-date-cell-selected {\n  background: #2563eb;\n  color: #ffffff !important;\n  font-weight: 700;\n  border-radius: 50%;\n}\n\n/* Today — bordered square (matches reference) */\n.ods-date-cell-today {\n  border: 1.5px solid #9ca3af;\n  border-radius: 4px; /* square not circle, matching reference */\n  color: #1a1a2e;\n}\n\n/* ── Footer: Clear / Today ── */\n.ods-date-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 14px;\n  padding-top: 10px;\n  border-top: 1px solid #f1f3f5;\n}\n\n.ods-date-footer-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.838rem;\n  font-weight: 600;\n  color: #2563eb;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: background 0.12s;\n}\n\n.ods-date-footer-btn:hover {\n  background: #eff6ff;\n}\n\n.ods-date-dot {\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 5px;\n  height: 5px;\n  background-color: #ef4444;\n  border-radius: 50%;\n}\n\n/* ── Dark theme ── */\n.dark .ods-date-filter-pill {\n  background: #1e293b;\n}\n\n.dark .ods-date-filter-pill:hover {\n  background: #334155;\n}\n\n.dark .ods-date-filter-text {\n  color: #e2e8f0;\n}\n\n.dark .ods-date-icon-left,\n.dark .ods-date-icon-right {\n  color: #94a3b8;\n}\n\n.dark .ods-date-dropdown {\n  background: #1e293b;\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.4),\n    0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.dark .ods-date-month-label {\n  color: #f1f5f9;\n}\n\n.dark .ods-date-nav-btn {\n  color: #94a3b8;\n}\n\n.dark .ods-date-nav-btn:hover {\n  background: #334155;\n}\n\n.dark .ods-date-day-label {\n  color: #64748b;\n}\n\n.dark .ods-date-cell {\n  color: #e2e8f0;\n}\n\n.dark .ods-date-cell:hover:not(.ods-date-cell-outside):not(.ods-date-cell-selected) {\n  background: #334155;\n}\n\n.dark .ods-date-cell-outside {\n  color: #475569;\n}\n\n.dark .ods-date-cell-today {\n  border-color: #64748b;\n  color: #e2e8f0;\n}\n\n.dark .ods-date-footer {\n  border-top-color: #334155;\n}\n\n.dark .ods-date-footer-btn:hover {\n  background: #1e3a5f;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
